const map = {
	"./WhatsApp Image 2025-01-17 at 11.50.39 PM (1).jpeg": 3627,
	"./WhatsApp Image 2025-01-17 at 11.50.39 PM.jpeg": 5605,
	"./WhatsApp Image 2025-01-17 at 11.50.40 PM (1).jpeg": 6539,
	"./WhatsApp Image 2025-01-17 at 11.50.40 PM.jpeg": 6197,
	"./WhatsApp Image 2025-01-17 at 11.50.41 PM (1).jpeg": 2098,
	"./WhatsApp Image 2025-01-17 at 11.50.41 PM.jpeg": 4296,
	"./WhatsApp Image 2025-01-17 at 11.50.42 PM (1).jpeg": 5765,
	"./WhatsApp Image 2025-01-17 at 11.50.42 PM (2).jpeg": 6666,
	"./WhatsApp Image 2025-01-17 at 11.50.42 PM.jpeg": 444
};


function webpackContext(req) {
	const id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		const e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2740;